import React, { useEffect, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';

import img1 from '../images/amenity1.webp';
import amenities2 from '../images/amenity2.webp';
import amenities3 from '../images/amenity3.webp';
import amenities4 from '../images/amenity4.webp';

import icon1 from '../images/icon1.webp';
import icon2 from '../images/icon2.webp';
import icon3 from '../images/icon3.webp';
import icon4 from '../images/icon4.webp';
import icon5 from '../images/icon5.webp';
import icon6 from '../images/icon6.webp';
import icon7 from '../images/icon7.webp';
import icon8 from '../images/icon8.webp';

const Amenities = () => {
  const scrollRef = useRef(null);
  const isMobile = useMediaQuery({ query: '(max-width: 991px)' });

  const items = [
    { icon: "/aicon1.png", title: 'Exclusive Clubhouse' },
    { icon: "/aicon2.png", title: 'Swimming Pool' },
    { icon: "/aicon3.png", title: 'Gym & Sports' },
    { icon: "/aicon4.png", title: 'Yoga / Aerobics Room' },
    { icon: "/aicon5.png", title: 'Amphitheatre' },
    { icon: "/aicon6.png", title: 'Jogging' },
    { icon: "/aicon7.png", title: 'Cycling Track' },
    { icon: "/aicon8.png", title: 'Landscaped Gardens' },
  ];
  useEffect(() => {
    if (!isMobile || !scrollRef.current) return;

    const container = scrollRef.current;

    let scrollAmount = 0;

    const interval = setInterval(() => {
      if (!container) return;

      scrollAmount += 1;

      container.scrollTo({
        left: scrollAmount,
        behavior: "smooth",
      });

      // reset loop
      if (
        scrollAmount >=
        container.scrollWidth - container.clientWidth
      ) {
        scrollAmount = 0;
      }
    }, 25);

    return () => clearInterval(interval);
  }, [isMobile]);
  return (
    <div className="amenities-section" id='amenities'>
      <Container>
        <div className="text-center amenities-header">
          <h2>Unmatched Amenities For A Premium Lifestyle</h2>
          <p className='text-capitalize'>
            Enjoy the best of modern living with state-of-the-art amenities
            designed for every family member.
          </p>
        </div>

        <Row className="align-items-end">
          {!isMobile && (
            <Col lg={2} className="side-image">
              <img src={img1} alt="amenities" />
            </Col>
          )}

          <Col lg={8}>
            <div className="amenities-grid">
              {items.map((item, index) => (
                <div className="amenity-box" key={index}>
                  <img src={item.icon} alt={item.title} />
                  <h6>{item.title}</h6>
                </div>
              ))}
            </div>

            {isMobile ? (
              <div
                className="marquee-wrapper"
                onClick={(e) => {
                  const track = e.currentTarget.querySelector(".marquee-track");

                  track.classList.add("paused");

                  clearTimeout(track.pauseTimeout);

                  track.pauseTimeout = setTimeout(() => {
                    track.classList.remove("paused");
                  }, 10000);
                }}
                onTouchStart={(e) => {
                  const track = e.currentTarget.querySelector(".marquee-track");

                  track.classList.add("paused");

                  clearTimeout(track.pauseTimeout);

                  track.pauseTimeout = setTimeout(() => {
                    track.classList.remove("paused");
                  }, 10000);
                }}
              >
                <div className="marquee-track">

                  <img src={amenities2} alt="amenities" />
                  <img src={amenities3} alt="amenities" />
                  <img src={amenities2} alt="amenities" />
                  <img src={amenities3} alt="amenities" />

                  {/* duplicate */}
                  <img src={amenities2} alt="amenities" />
                  <img src={amenities3} alt="amenities" />
                  <img src={amenities2} alt="amenities" />
                  <img src={amenities3} alt="amenities" />

                </div>
              </div>
            ) : (
            <Row className="mt-4">
              <Col md={6} className="bottom-img">
                <img src={amenities3} alt="amenities" />
              </Col>

              <Col md={6} className="bottom-img">
                <img src={amenities2} alt="amenities" />
              </Col>
            </Row>
            )}
          </Col>

          {!isMobile && (
            <Col lg={2} className="side-image">
              <img src={amenities4} alt="amenities" />
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default Amenities;
